let computerModel = {
    AssetType: "computer",
    client: "default",
    Discovery: {
      AssetTag: null,
      Location: null,
      CpuTitle: null,
      HddTitle: null,
      RamTitle: null,
      OsTitle: "Windows 10",
      Status: "ready",
      SystemInfo: {
        Make: null,
        Model: null,
        Serial: null,
      },
      Mode: "offline",
      Time: null,
    },
    sku: null,
    mischardwarespec: {
      conditionDesc: null,
      computerType: null,
      screensize: null,
      color: null,
      storageType: null,
      displayPort: false,
      ethernet: false,
      minidisplayport: false,
      hdmi: false,
      microHDMI: false,
      microUSB: false,
      miniEthernet: false,
      miniUSB: false,
      usb1: false,
      usb2: false,
      lanCard: false,
      camera3d: false,
      backLitKeyboard: false,
      bluetooth: false,
      microphone: false,
      webcam: false,
      hsdpa: false,
      rugged: false,
      tabletPC: false,
      touchScreen: false,
    },
    Time: null
  }

  export default computerModel